/* @flow */

export const gutter = 8;
